var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('switchingcentres',{attrs:{"switchingcentres":_vm.switchingCentres,"isloading":_vm.isLoading},on:{"switchingCentreSaved":function($event){return _vm.fetchSwitchingCentres()},"switchingCentreAdded":function($event){return _vm.setLocationLength()},"searchInitiated":function($event){return _vm.setLocationLength()}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }